import React from 'react';
import { connect } from 'react-redux';
import DataModelReportsDialog from './DataModelReportsDialog';
import DictionaryReportDialog from './DictionaryReportDialog';
import DictionaryReportsDialog from './DictionaryReportsDialog';

const DatasetReportDialogs = ({
  allowDataModelReport,
  allowReport,
  allowReports,
  theme,
}) => (
  <>
    {allowDataModelReport && (<DataModelReportsDialog theme={theme} />)}
    {allowReport && (<DictionaryReportDialog theme={theme} />)}
    {allowReports && (<DictionaryReportsDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { update } } } },
  datasetReports: {
    dataModelReportsDialog,
    dictionaryReportDialog,
    dictionaryReportsDialog,
  },
}) => ({
  allowDataModelReport: dataModelReportsDialog.open && update,
  allowReport: dictionaryReportDialog.open && update,
  allowReports: dictionaryReportsDialog.open && update,
});

export default connect(mapStateToProps)(DatasetReportDialogs);
